import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export default function SubscribePopup() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    // Never show to already-subscribed users
    if (localStorage.getItem('subscribed') === 'true') return;

    // Show once every 3rd visit
    const count = parseInt(localStorage.getItem('visitCount') || '0') + 1;
    localStorage.setItem('visitCount', String(count));
    if (count % 3 === 0) {
      setTimeout(() => setOpen(true), 5000);
    }
  }, []);

  const handleSubmit = async () => {
    // TODO: Connect to email marketing platform (Mailchimp / MailerLite / etc.)
    // Client needs to provide API key and list ID — store in Replit Secrets
    // TODO: Once connected, set up a Welcome Email automation that delivers
    // the bonus content (excerpt / short story / playlist) to new subscribers
    console.log('Subscribe:', email);
    localStorage.setItem('subscribed', 'true');
    setSubmitted(true);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="bg-gothic-charcoal border border-gothic-gray max-w-md">
        <DialogHeader>
          <DialogTitle className="font-cinzel text-xl text-gothic-white">
            {submitted ? 'You\'re in!' : 'Enter the Reader Vault'}
          </DialogTitle>
        </DialogHeader>
        {submitted ? (
          <p className="text-gray-400 text-sm">
            Check your inbox for your free excerpt of BROKEN THINGS.
          </p>
        ) : (
          <>
            <p className="text-gray-400 text-sm">Join and receive a free copy of Skin and Bones — plus exclusive updates, sneak peeks, and gripping thriller tales delivered straight to your inbox.</p>
            <div className="flex gap-2 mt-4">
              <Input
                type="email"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-gothic-black border-gothic-gray text-gothic-white placeholder:text-gray-600"
              />
              <Button onClick={handleSubmit} className="bg-blood-red hover:bg-red-700">Subscribe</Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
